import { Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import {BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DocumentsService } from '../services/documents-service/documents.service';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface IRequestOfRows {
  limit: number;
  skip: number;
  filters: any;
  conds: any;
  ordering: any;
}

class BaseDocumentsCercadorComponent {
  public elementList: {'offset':0, 'registers':0, 'rows': Array<any>};

  public sendRows(req: IRequestOfRows) {
    this.requestService.getActive(req.limit, req.skip, req.filters, req.conds, req.ordering)
      .subscribe(
        elements => this.elementList = elements,
        error => console.log(error)
      );
  }
  constructor(public translate: TranslateService, public languageService: LanguageService, private requestService: DocumentsService) {
  }
}

@Component({
  selector: 'mcrit-gestio-documents-cercador',
  template: `
    <mcrit-gestio-documents-list
      (requestRows)="sendRows($event)"
      [elementList]="elementList">
    </mcrit-gestio-documents-list>`,
  styleUrls: ['documents-cercador.component.css'],
  providers: [  ]
})

export class DocumentsCercadorComponent extends BaseDocumentsCercadorComponent {
  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(public translate: TranslateService, public languageService: LanguageService, documentsService: DocumentsService) {
    super(translate, languageService, documentsService);
  }

  ngOnInit(){
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
